import { combineReducers } from 'redux';
/* Common Fields */
import { fields } from './fields';

/* Vehicles */
import { vehicles } from './vehicles';
import { filters } from './filters';

/* Vehicles Card */
import { vehicleStatus } from './archivingVehicle';
// import { updatingVehicleStatus } from './updateVehicle';

/* Add Vehicles Card */
import { addingVehicleStatus } from './addVehicle';
import { autoSearch } from './autoSearch';
import { interfaceSettings } from './interface';

export const Fields = fields;

export const Vehicles = combineReducers({
  vehicles,
  filters,
});

export const VehicleCard = combineReducers({
  vehicleStatus,
  // updatingVehicleStatus,
});

export const AddVehicle = combineReducers({
  addingVehicleStatus,
  autoSearch,
  interfaceSettings,
});
